import React,{useState} from 'react';
import { Box,CircularProgress,IconButton } from '@mui/material';
import { DataGrid,GridColDef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useSearchParams } from 'react-router-dom';
import { useTables } from '../hooks/useTables.ts';
import apiService from '../services/apiService.ts';
import GridEmpty from '../components/GridEmpty.tsx';
import TableDialog from '../components/TableDialog.tsx';

const TablesPage:React.FC=()=>{
  const [params]=useSearchParams();
  const spaceId=params.get('spaceId')||'';
  const { rows,loading,refetch }=useTables(spaceId);
  const [dialogOpen,setDialogOpen]=useState(false);
  const [editing,setEditing]=useState<any|null>(null);

  const handleDelete=async(id:string)=>{await apiService.deleteTable(spaceId,id);refetch();};

  const cols:GridColDef[]=[
    {field:'id',headerName:'ID',width:80},
    {field:'name',headerName:'Name',flex:1},
    {field:'seats',headerName:'Seats',width:120},
    {field:'actions',headerName:'',width:120,renderCell:(p)=>(
      <>
        <IconButton onClick={()=>{setEditing(p.row);setDialogOpen(true);}}><EditIcon/></IconButton>
        <IconButton onClick={()=>handleDelete(p.row.id)}><DeleteIcon/></IconButton>
      </>
    )}
  ];

  return(
    <Box p={2}>
      <IconButton color="primary" onClick={()=>{setEditing(null);setDialogOpen(true);}}><AddIcon/></IconButton>
      {loading? <CircularProgress/>:(
        <DataGrid rows={rows} columns={cols} autoHeight components={{ NoRowsOverlay: GridEmpty }} />
      )}
      <TableDialog open={dialogOpen} onClose={()=>setDialogOpen(false)} spaceId={spaceId} initial={editing} onSaved={refetch}/>
    </Box>
  );
};
export default TablesPage;